import { render, staticRenderFns } from "./ReceiptRefund.vue?vue&type=template&id=6a9b175d"
import script from "./ReceiptRefund.vue?vue&type=script&lang=js"
export * from "./ReceiptRefund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports